import React from 'react';
import { map } from 'lodash';
import CustomizationTable from './CustomizationTable';

/**
 * @typedef {object} CustomizationTableSectionProps
 * @property {Array<Object>} [reports]
 */

/**
 * @param {CustomizationTableSectionProps} props
 */
const CustomizationTableSection = props => {
  const { reports } = props;

  return (
    <div className='appraisal-view-customization__tables-wrapper'>
      <p className='bold'>Selected Tables</p>
      {map(reports, (report, index) => (
        <CustomizationTable key={report.uuid} tableNumber={index + 1} report={report} />
      ))}
    </div>
  );
};

export default CustomizationTableSection;
